import React from 'react';

import HideElementSettings from '../HideElementSettings';

function NewsSetting() {
    return <HideElementSettings field="show_news_image" label="Show news image" settingKey="news_image_visible" />;
}

export default NewsSetting;
